<div id="court-selection-component">
  <div
    class="court-selection-row"
    *ngFor="let dropdownOptions of dropdownOptionsArray; let index = index"
  >
    <fsx-basic-single-selection
      #selectionField1
      *ngIf="dropdownOptions.length"
      [caption]="labelsArray[index]"
      [hint]="'Select Option'"
      [width]="'100%'"
      [inputDropdownOptions]="dropdownOptions"
      (formControlEmitter)="setControl($event)"
      (selectedValue)="selectedValue($event, index)"
      (clearValue)="clearDropdown(index)"
    ></fsx-basic-single-selection>
  </div>

  <div class="court-selection-row" *ngIf="courtDropdownOptions.length">
    <fsx-basic-single-selection
      #selectionField2
      [caption]="'Court'"
      [hint]="'Select Option'"
      [width]="'100%'"
      [inputDropdownOptions]="courtDropdownOptions"
      (selectedValue)="selectedValue($event, null)"
      (clearValue)="clearDropdown()"
    ></fsx-basic-single-selection>
  </div>
</div>
